import MobileDetect from 'mobile-detect'

$(function() {
    $('.js-scroll-to-platform-links').on('click', function (event){
        event.preventDefault();
        var  dn = $('#js-platform-links').offset().top;
        $('html, body').animate({scrollTop: dn}, 500);
    });

    $('.j-for-mobile-close').on('click', function(event){
        Cookies.set('j_for_mobile_hided', 1, { expires: 7 });
        $('.j-for-mobile-sticker').hide();
    });

    if ( ! Cookies.get('j_for_mobile_hided') ) {
        var md = new MobileDetect(window.navigator.userAgent);
        const deviceOS  = (md.os() || '').toLowerCase();

        $('.j-for-mobile-sticker').addClass('f-trading-platforms__for-mobile-is-' + deviceOS);
    }
});


const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('showed');
        }
    });
});

document.querySelectorAll('.f-trading-platforms__advantages li').forEach(element => {
    observer.observe(element);
});
